export default __webpack_public_path__ + "static/media/Teresa Cox .bdf09d74.jpg";